import { Box, Stack } from '@mui/material';
import React from 'react';
import { AccessDeniedView } from 'src/modules/authentication/components';
import { EditContactDrawer } from 'src/modules/contacts/components/EditContactDrawer';
import { useInboxViewController } from '../../controllers';
import Chat from '../Chat';
import InboxLeftSection from '../InboxLeftSection';

export const InboxView = () => {
  const c = useInboxViewController();

  if (c.isForbidden) {
    return <AccessDeniedView />;
  }

  return (
    <Stack width="100%" direction={c.isMobile ? 'column' : 'row'}>
      <EditContactDrawer {...c.editContactDrawerController} refreshContacts={c.refreshContacts} />

      <Box display={c.isMobile && c.showChatView ? 'none' : 'block'} width={c.isMobile ? '100%' : 263}>
        <InboxLeftSection
          onlyMyConversations={c.onlyMyConversations}
          setOnlyMyConversations={c.setOnlyMyConversations}
          isSpam={c.isSpam}
          setIsSpam={c.setIsSpam}
          isInvalidContacts={c.isInvalidContacts}
          setIsInvalidContacts={c.setIsInvalidContacts}
          search={c.search}
          users={c.users}
          fetchMoreData={c.fetchMoreData}
          hasMoreContacts={c.hasMoreContacts}
          totalContactsCount={c.totalContactsCount}
          handleNewChatClick={c.handleNewChatClick}
          isContactsLoading={c.isContactsLoading}
          isShowAll={c.isShowAll}
          applyFilter={c.applyFilter}
          toggleShowAll={c.toggleShowAll}
          selectedContact={c.selectedContact}
          onSearchContact={c.onSearchContact}
          onSelectContact={c.selectChat}
          setSelectedContact={c.setSelectedContactObject}
          contacts={c.contacts}
          setContactsOffset={c.setContactsOffset}
        />
      </Box>

      <Box
        display={c.isMobile && !c.showChatView ? 'none' : 'block'}
        minHeight="100%"
        height="100%"
        width={c.isMobile ? '100%' : 'calc(100vw - 420px)'}
      >
        <Chat
          messageTemplates={c.messageTemplates}
          refreshContacts={c.refreshContacts}
          setIsChatLoading={c.setIsChatLoading}
          isNewChat={c.isNewChat}
          users={c.users}
          onSelectContact={c.selectChat}
          ref={c.messagesRef}
          isChatLoading={c.isChatLoading}
          groups={c.groups}
          group={c.group}
          updateLinks={c.updateLinks}
          addMessage={c.addMessage}
          markMessageAsUnread={c.markMessageAsUnread}
          deleteScheduledMessage={c.deleteScheduledMessage}
          startReschedulingScheduledMessage={c.startReschedulingScheduledMessage}
          scheduledMessageToEdit={c.scheduledMessageToEdit}
          clearScheduledMessageToEdit={c.clearScheduledMessageToEdit}
          updateScheduledMessage={c.updateScheduledMessage}
          scheduledMessages={c.scheduledMessages}
          messages={c.chat}
          setSelectedContact={c.setSelectedContactObject}
          contact={c.selectedContactObject}
          customFields={c.customFields}
          isCompanyInSandBoxMode={c.isCompanyInSandBoxMode}
          isCompanyHasSubscription={c.isCompanyHasSubscription}
          showErrorDetails={c.showErrorDetails}
          hideDemoFails={c.hideDemoFails}
          newMessage={c.newMessage}
          openEditContact={c.editContactDrawerController.open}
          isMobile={c.isMobile}
          isContentReady={c.isContentReady}
          onBackToList={c.handleBackToList}
          hasMoreMessages={c.hasMoreMessages}
          isLoadingMoreMessages={c.isLoadingMoreMessages}
          onLoadMoreMessages={c.handleLoadMoreMessages}
        />
      </Box>
    </Stack>
  );
};
